<h2 mat-dialog-title>
  {{ 'LISTS.CAMPAIGN_DIALOG.TITLE' | translate: { name: userListName } }}
</h2>

<mat-dialog-content [ngClass]="useCustomEmail ? 'account-selection-long' : 'account-selection'">
  <div class="modal-subheader">
    {{ 'LISTS.CAMPAIGN_DIALOG.DEFAULT_ACCOUNT.TITLE' | translate }}
  </div>
  <mat-divider></mat-divider>
  <div class="modal-section">
    <div class="account-selector-text">
      {{ 'LISTS.CAMPAIGN_DIALOG.DEFAULT_ACCOUNT.MESSAGE' | translate }}
    </div>
    <div>
      <a href="{{ defaultAccountUrl }}" target="_blank" rel="noopener noreferrer">
        {{ 'COMMON.ACTION_LABELS.LEARN_MORE' | translate }}
      </a>
    </div>
  </div>
  <div class="account-selection-group">
    <mat-radio-group aria-label="Select an option" [(ngModel)]="useDefaultAccountGroup">
      <mat-radio-button color="primary" [value]="true">
        {{ 'LISTS.CAMPAIGN_DIALOG.DEFAULT_ACCOUNT.SELECT_AN_ACCOUNT' | translate }}
      </mat-radio-button>
      <div class="account-group-selector">
        <mat-form-field *ngIf="useDefaultAccountGroup" class="new-list-input" appearance="outline">
          <input
            type="text"
            matInput
            placeholder="{{ 'LISTS.CAMPAIGN_DIALOG.DEFAULT_ACCOUNT.SEARCH_SELECT_ACCOUNT' | translate }}"
            [formControl]="accountGroupSearch"
            [matAutocomplete]="auto"
            (input)="updateSearchTerm($event)"
          />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option
              *ngFor="let accountGroup of accountGroups$ | async"
              [value]="accountGroup"
              (onSelectionChange)="selectAccount(accountGroup)"
              style="height: auto"
            >
              <div matLine>{{ accountGroup.napData.companyName }}</div>
              <ng-container *ngIf="accountGroup.napData.address">
                <div matLine class="address">
                  {{ accountGroup.napData.address }}
                </div>
              </ng-container>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <mat-radio-button color="primary" [value]="false" (click)="selectAccount(null)">
        {{ 'USERS.BULK_IMPORT.USER_LIST_STEP.SKIP' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <ng-container *ngIf="!useDefaultAccountGroup">
    <glxy-alert
      type="warning"
      [showAction]="true"
      actionTitle="{{ 'COMMON.ACTION_LABELS.LEARN_MORE' | translate }}"
      (actionClick)="defaultAccountLearnMore()"
    >
      {{ 'LISTS.CAMPAIGN_DIALOG.DEFAULT_ACCOUNT.WARNING' | translate }}
    </glxy-alert>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose color="primary" (click)="close(null)">
    {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
  </button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedAccountGroup && useDefaultAccountGroup"
    (click)="startCampaign()"
  >
    {{ 'LISTS.CAMPAIGN_DIALOG.SUBMIT' | translate }}
  </button>
</mat-dialog-actions>
